module.exports = __webpack_public_path__ + "static/hvhh-2-6b15dd4a74787ac11d71a1d37252ecb5.png";